module.exports = __webpack_public_path__ + "static/images/winter-olympics.d80f1d44111e260b81f4e08f89a9fcfe.jpg";